

export class Texts{
    FaTexts: { [key: string]: string; }={};
    Texts: { [key: string]: string; }={};

    Init(){
        this.FaTexts["login1"] = "به ویست‌نپ خوش آمدید"
        this.FaTexts["login2"] = "لطفا شماره موبایل خود را وارد کنید"
        this.FaTexts["login3"] = "ورود"
        this.FaTexts["login4"] = "شماره موبایل صحیح نیست"
        this.FaTexts["login5"] = "شماره موبایل را وارد کنید"
        this.FaTexts["signin1"] = "ثبت نام"
        this.FaTexts["signin2"] = "نام و نام خانوادگی"
        this.FaTexts["signin3"] = "(ایمیل (اختیاری" 
        this.FaTexts["signin4"] = "نام و نام خانوادگی را وارد کنید"
        this.FaTexts["signin5"] = "ایمیل اشتباه است"
        this.FaTexts["signin6"] = "نام و نام خانوادگی:"
        this.FaTexts["signin7"] = "شماره موبایل:"
        this.FaTexts["signin8"] = "ایمیل (اختیاری):" 
        this.FaTexts["six-digit1"] = "لطفا کد شش رقمی ارسال شده را وارد کنید"
        this.FaTexts["six-digit2"] = "تایید"
        this.FaTexts["six-digit3"] = "ارسال مجدد کد"
        this.FaTexts["six-digit4"] = "تغییر شماره موبایل"
        this.FaTexts["main-page1"] = "(اعتبار شما (تومان"
        this.FaTexts["main-page2"] = "کیف پول"
        this.FaTexts["main-page3"] = "ثبت درخواست"
        this.FaTexts["main-page4"] = "پروفایل"
        this.FaTexts["main-page5"] = "تماس با ما"
        this.FaTexts["main-page6"] = "درباره ما"
        this.FaTexts["main-page7"] = "تبادلات"
        this.FaTexts["waste-list1"] = "پسماند مخلوط"
        this.FaTexts["waste-list2"] = "کارتن و کاغذ"
        this.FaTexts["waste-list3"] = "شیشه ای"
        this.FaTexts["waste-list4"] = "قوطی"
        this.FaTexts["waste-list5"] = "پلاستیکی"
        this.FaTexts["waste-list6"] = "حلبی"
        this.FaTexts["waste-list7"] = "نان خشک"
        this.FaTexts["waste-list8"] = "لطفا پسماند خود را انتخاب کنید"
        this.FaTexts["waste-list9"] = "برنج"
        this.FaTexts["waste-list10"] = "الکترونیکی"
        this.FaTexts["waste-list11"] = "آهن"
        this.FaTexts["waste-list12"] = "مس"
        this.FaTexts["waste-list13"] = "چدن"
        this.FaTexts["waste-list14"] = "PET"
        this.FaTexts["waste-list15"] = "سبد"
        this.FaTexts["waste-list16"] = "لاک"
        this.FaTexts["waste-list17"] = "آلومینیوم سبک"
        this.FaTexts["waste-list18"] = "آلومینیوم سنگین"
        this.FaTexts["selected-items1"] = "قیمت کل خرید (تومان): "
        this.FaTexts["selected-items2"] = " قیمت هر کیلوگرم (تومان): "
        this.FaTexts["selected-items3"] = "ثبت نهایی درخواست"
        this.FaTexts["profile1"] = "شماره موبایل"
        this.FaTexts["profile2"] = "ویرایش پروفایل"
        this.FaTexts["profile3"] = "خروج از حساب کاربری"
        this.FaTexts["about-us1"] = "درباره ویست‌نپ"
        this.FaTexts["wallet1"] = "کیف پول"
        this.FaTexts["wallet2"] = ":شماره شبا یا شماره حساب"
        this.FaTexts["wallet3"] = ":مبلغ"
        this.FaTexts["wallet4"] = " :اعتبار شما"
        this.FaTexts["wallet5"] = "حداقل مبلغ برای برداشت 10,000 تومان می باشد"
        this.FaTexts["wallet6"] = "ثبت درخواست"
        this.FaTexts["wallet7"] = "(IR بدون)"
        this.FaTexts["done1"] = "سفارش شما با موفقیت ثبت شد"
        this.FaTexts["done2"] = "یک وانت تا حداکثر دو ساعت دیگر زباله شما را تحویل می گیرد"
        this.FaTexts["done3"] = "بازگشت به صفحه اصلی"
        this.FaTexts["history1"] = "تاریخچه سفارشات"
        this.FaTexts["get-location1"] = "آدرس را وارد کنید"
        this.FaTexts["services1"] = "لطفا نوع درخواست را انتخاب کنید"

        this.Texts=this.FaTexts;

    }



}

